module.exports = __webpack_public_path__ + "static/img/newenergy1.b54f76b3.png";